"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDriverWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var AddDriverWidget = exports.AddDriverWidget = /** @class */ (function (_super) {
    __extends(AddDriverWidget, _super);
    function AddDriverWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.drivers = [];
        _this.renderDriversRadio = function () {
            return _this.drivers.map(function (driver, index) { return (React.createElement("div", { key: driver.personId, className: "custom-control margin-bottom-20-padding-left-0" },
                React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "additional-driver", id: "additional-driver-id-" + index, value: driver.personId, onChange: _this.handleOnChangeEvent }),
                React.createElement("label", { className: "checkbox-label driver-label cursor-pointer", htmlFor: "additional-driver-id-" + index }, "".concat(driver.firstName, " ").concat(driver.lastName)))); });
        };
        _this.renderNewDriverRadio = function () {
            return (React.createElement("div", { className: "custom-control margin-bottom-20-padding-left-0" },
                React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "additional-driver", id: "additional-driver", value: "new", onChange: _this.handleOnChangeEvent }),
                React.createElement("label", { className: "checkbox-label driver-label cursor-pointer", htmlFor: "additional-driver" }, "New driver")));
        };
        _this.handleOnChangeEvent = function (event) {
            _this.setState({ driverToAdd: event.target.value });
        };
        _this.handleClickNext = function () {
            if (_this.state.driverToAdd === "new" && _this.navigateToPageIfNew) {
                _this.props.engine.navigate(_this.navigateToPageIfNew, true);
            }
            else if (_this.navigateToPageIfExisting) {
                _this.vehicle.driverIds = __spreadArray(__spreadArray([], _this.state.existingDriverIds, true), [_this.state.driverToAdd], false);
                _this.props.onStateChange("vehicles[".concat(_this.vehicleIndex, "]"), _this.vehicle);
                _this.props.onStateChange("uistate.driverId", _this.state.driverToAdd);
                _this.props.engine.navigate(_this.navigateToPageIfExisting, true);
            }
        };
        _this.state = {
            driverToAdd: ""
        };
        _this.navigateToPageIfExisting = _this.getSetting("navigateToPageIfExisting", undefined);
        _this.navigateToPageIfNew = _this.getSetting("navigateToPageIfNew", undefined);
        _this.addingDriversToNewVehicle = _this.getSetting("addingDriversToNewVehicle", false);
        _this.vehicleIndex = _this.getSetting("vehicleIndex", undefined);
        _this.vehicle = _this.props.interaction.vehicles[_this.vehicleIndex];
        _this.isReplaceCarJourney = _this.getSetting("isReplaceCarJourney", false);
        return _this;
    }
    AddDriverWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies().subscribe(function (policies) {
            var _a;
            var originalPolicy = policies.filter(function (p) { return p.interaction._id === _this.props.interaction.uistate.relativeInteractionId; });
            var driverIds;
            var interaction = _this.props.engine.getInteraction();
            if (_this.addingDriversToNewVehicle) {
                driverIds = _this.props.interaction.vehicles[0].driverIds;
            }
            else {
                driverIds = [].concat.apply([], originalPolicy.map(function (policy) { return policy.interaction.vehicles[0].driverIds.map(function (id) { return id; }); }));
            }
            if (_this.props.interaction.uistate.drivers) {
                (_a = _this.drivers).push.apply(_a, _this.props.interaction.uistate.drivers.filter(function (driver) { return !driverIds.includes(driver.personId); }));
            }
            if (!_this.vehicle.driverIds.includes(_this.props.interaction.policyHolder.personId)) {
                _this.drivers.push(_this.props.interaction.policyHolder);
            }
            if (_this.isReplaceCarJourney) {
                _this.props.engine.navigate("addAdditionalDriver".concat(interaction.additionalDrivers.length + 1, "DrivingLicenceScanPage"), false);
            }
            if (!_this.isReplaceCarJourney && _this.drivers.length === 0 && _this.navigateToPageIfNew) {
                _this.props.engine.navigate(_this.navigateToPageIfNew, false);
            }
            _this.setState({ existingDriverIds: driverIds });
        });
    };
    AddDriverWidget.prototype.render = function () {
        var _this = this;
        if (this.state.existingDriverIds) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "_panel-dashboard form-group pb-md-3" },
                    React.createElement("label", { className: "font-weight-extra-light" },
                        "Please choose whether you want to",
                        React.createElement("span", { className: "font-weight-semi-bold" }, " add an existing or a new driver "),
                        "to ",
                        this.vehicle.make,
                        ", ",
                        this.vehicle.model,
                        " (",
                        this.vehicle.registrationNumber,
                        ")"),
                    React.createElement("div", { className: "input-group d-block" },
                        this.renderDriversRadio(),
                        this.renderNewDriverRadio())),
                React.createElement("button", { type: "button", id: "addDriver", className: this.state.driverToAdd === "" ? "btn btn-disabled-dashboard float-md-right mt-3" : "btn btn-blue-dashboard float-md-right mt-3", onClick: function (e) { return _this.state.driverToAdd === "" ? e.preventDefault() : _this.handleClickNext(); } }, "Next")));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AddDriverWidget.prototype, "customerPortalService", void 0);
    return AddDriverWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AddDriverWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/AddDriverWidget.js
// module id = 3160
// module chunks = 0